function initializeAnimations() {

    /* ------------------------------
       HERO BANNER
    ------------------------------ */

    // Hero Heading
    applyAnimation(".banner__heading", "fade-up", 0);

    // Hero Description
    applyAnimation(".banner__text", "fade-up", 150);

    // Buttons
    applyAnimation(".banner__buttons .button", "zoom-in", 300);

    // Hero Image
    applyAnimation(".banner__media", "fade-left", 500);

    // Hero Badge (if present)
    applyAnimation(".banner__box .badge", "fade-down", 0);

    // Hero Content Box
    applyAnimation(".banner__box", "fade-right", 0);

    /* ------------------------------
       COLLECTIONS
    ------------------------------ */

    applyAnimation(".collection-list .card", "zoom-in", 100);

    /* ------------------------------
       PRODUCTS
    ------------------------------ */

    applyAnimation(".card-wrapper", "fade-up", 0);

    /* ------------------------------
       IMAGE WITH TEXT
    ------------------------------ */

    applyAnimation(".image-with-text__media", "fade-right", 100);
    applyAnimation(".image-with-text__content", "fade-left", 200);

    /* ------------------------------
       MULTICOLUMN
    ------------------------------ */

    applyAnimation(".multicolumn-card", "fade-up", 100);

    /* ------------------------------
       RICH TEXT
    ------------------------------ */

    applyAnimation(".rich-text", "fade-up", 100);

    /* ------------------------------
       FOOTER
    ------------------------------ */

    applyAnimation(".footer-block", "fade-up", 100);

    AOS.refreshHard();

}